import React, { VFC } from 'react';
import styled from 'styled-components';
import Typography from '../atoms/Typography';

interface Props {
  title: string | React.ReactElement;
  value: string | number | undefined;
}

const StyledTableItem = styled.div`
  padding-right: 32px;
`;

const TableItem: VFC<Props> = ({ title, value }) => (
  <StyledTableItem>
    <Typography variant="body1-semi-bold">{title}</Typography>
    <Typography variant="body2">{value}</Typography>
  </StyledTableItem>
);

export default TableItem;
